import { useMutation } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

interface GenerateModelAnswerRequest {
  questionId: string;
  imageDataUrl?: string; // Optional: base64 image for Section B Image questions
}

interface GenerateModelAnswerResponse {
  model_answer: string;
  cached: boolean;
}

const useGenerateModelAnswer = () => {
  return useMutation({
    mutationFn: async ({ questionId, imageDataUrl }: GenerateModelAnswerRequest): Promise<GenerateModelAnswerResponse> => {
      const { data: { session } } = await supabaseClient.auth.getSession();

      if (!session) {
        throw new Error('Not authenticated');
      }

      const response = await supabaseClient.functions.invoke('generate-model-answer', {
        body: {
          question_id: questionId,
          image_data_url: imageDataUrl,
        },
      });

      if (response.error) {
        throw new Error(response.error.message || 'Failed to generate model answer');
      }

      return response.data;
    },
  });
};

export default useGenerateModelAnswer;
